import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import logger from "@insite/client-framework/Logger";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setNavDrawerIsOpen from "@insite/client-framework/Store/Components/AddressDrawer/Handlers/SetNavDrawerIsOpen";
import {
    getCurrentUserIsGuest,
    getIsPunchOutSession,
    getSettingsCollection,
} from "@insite/client-framework/Store/Context/ContextSelectors";
import cancelPunchOut from "@insite/client-framework/Store/Context/Handlers/CancelPunchOut";
import signOut from "@insite/client-framework/Store/Context/Handlers/SignOut";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import loadCurrentShipTo from "@insite/client-framework/Store/Data/ShipTos/Handlers/LoadCurrentShipTo";
import { getCurrentShipToState, getShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { useMergeStyles } from "@insite/content-library/additionalStyles";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import Drawer, { DrawerPresentationProps } from "@insite/mobius/Drawer/Drawer";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden from "@insite/mobius/Hidden/Hidden";
import Icon, { IconPresentationProps, IconWrapper } from "@insite/mobius/Icon/Icon";
import ChevronDown from "@insite/mobius/Icons/ChevronDown";
import User from "@insite/mobius/Icons/User";
import Link, { LinkPresentationProps, StyledIcon } from "@insite/mobius/Link";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";
import Menu, { MenuPresentationProps } from "@insite/mobius/Menu";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ADILiveChatComponent from "@NA/Components/ADILiveChatComponent";
import toggleLoginDrawer from "@NA/Handlers/ADILoginDrawerHandler";
import toggleRewardsDrawer from "@NA/Handlers/ADIRewardsDrawerHandler";
import { IsXtenAllowedUser } from "@NA/Hooks/useAdiXtenIntegrationHelper";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import ADIColors from "@NA/Utils/ADIColors";
import { checkVaildUserForHmiRewards, formatUserId, getMenuItems, preventBackNavigation } from "@NA/Utils/Utility";
import loadLoyaltyRewards from "@NA/Widgets/LoyaltyRewards/LoyaltyRewardsHandler";
import { clearCoveoTokenAndOrg } from "@NA/Services/ADICoveoService";
import React, { useEffect, useRef, useState } from "react";
import { connect, ResolveThunks, useDispatch, useSelector } from "react-redux";
import { css } from "styled-components";
import loadLoyaltyRewardsUser from "@NA/Widgets/LoyaltyRewards/LoyaltyRewardsUserHandler";
import DispatchGetcustomerStatusApi from "@NA/Widgets/NewCustomerPricingStatus/PricingStatusHandler";
import useLocation from "@NA/Hooks/useLocation";
const enum fields {
    visibilityState = "visibilityState",
    icon = "icon",
    includeAccountMenu = "includeAccountMenu",
}

const mapStateToProps = (state: CustomApplicationState) => {
    const session = state.context.session;
    const cart = getCurrentCartState(state);
    const shipToId = session.shipToId;
    const shipToState = getShipToState(state, shipToId);
    const billToState = getBillToState(state, cart?.value?.billToId);
    const showAdminMenuonSite = state.context.settings.settingsCollection.maNavSettingSettings?.showAdminMenuonSite;
    const showMyAccMenuItems = state.context.settings.settingsCollection.maNavSettingSettings;
    const signInPage = getPageLinkByPageType(state, "SignInPage");
    const currentPageType = getCurrentPage(state).type;

    return {
        session: state.context.session,
        isSignInPage: currentPageType === "SignInPage",
        signInPageUrl: signInPage?.url,
        isCheckoutPage: currentPageType === "CheckoutReviewAndSubmitPage",
        isSigningIn: state.context.isSigningIn,
        firstName: state.context.session.firstName,
        lastName: state.context.session.lastName,
        userName: state.context.session.userName,
        myAccountPageLink: getPageLinkByPageType(state, "MyAccountPage"),
        signInUrl: getPageLinkByPageType(state, "SignInPage")?.url,
        currentUserIsGuest: getCurrentUserIsGuest(state),
        isPunchOutSession: getIsPunchOutSession(state),
        currentLocation: getLocation(state),
        displayChangeCustomerLink: state.context.session?.displayChangeCustomerLink || false,
        cart,
        billToState,
        shipToState,
        toggleDrawer: state.ADIGlobalData.loginDrawerStore.loginDrawer,
        currentShipToState: getCurrentShipToState(state),
        userRoles: state.context.session.userRoles,
        showAdminMenuonSite,
        showMyAccMenuItems,
        isAuthenticated: session && (session.isAuthenticated || session.rememberMe) && !session.isGuest,
        timeoutSetting: state.context.settings.settingsCollection.extendedWebsiteSettings?.siteTimeoutSetting,
    };
};

const mapDispatchToProps = {
    signOut,
    cancelPunchOut,
    toggleLoginDrawer,
    setNavDrawerIsOpen,
    toggleRewardsDrawer,
    loadCurrentShipTo,
};

export interface HeaderSignInStyles {
    loadingOverlay?: InjectableCss;
    signOutWrapper?: InjectableCss;
    titleClickable?: ClickablePresentationProps;
    titleIcon?: IconPresentationProps;
    titleTypography?: TypographyPresentationProps;
    signOutClickable?: ClickablePresentationProps;
    menu?: MenuPresentationProps;
    signInDrawer?: DrawerPresentationProps;
    myAccountMenuTitle: InjectableCss;
    myAccountMenuGridContainer: GridContainerProps;
    myAccountMenuGridItem: GridItemProps;
    myAccountMenuLink: LinkPresentationProps;
    chatWithUs: InjectableCss;
    chatWithUsLink: LinkPresentationProps;
    divider: InjectableCss;
    mainWraper: InjectableCss;
    mainWraperLast: InjectableCss;
    mainWraperText: InjectableCss;
    mainWraperHint: InjectableCss;
    mainWraperLink: InjectableCss;
    customerNumber: InjectableCss;
    addressInfo: InjectableCss;
    adiModal: InjectableCss;
}

export const headerSignInStyles: HeaderSignInStyles = {
    loadingOverlay: {
        css: css`
            & > div:first-child {
                &[data-loading="true"] {
                    width: 100%;
                }
            }
        `,
    },
    signOutWrapper: {
        css: css`
            display: inline-flex;
            padding: 0px;
            ${IconWrapper} {
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                color: ${getColor("common.background")} !important;
                            `,
                            null,
                            null,
                            null,
                        ],
                        "max",
                    );
                }}
            }
        `,
    },
    titleClickable: {
        css: css`
            display: flex;
            height: 100%;
            flex-direction: column;
            justify-content: center;
            align-items: flex-end;
            margin: 0px;
            &:focus {
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            null,
                            css`
                                outline-color: ${ADIColors.darkBlack3};
                                outline-style: ${getProp("theme.focus.style", "solid")};
                                outline-width: 0px;
                            `,
                        ],
                        "min",
                    );
                }}                  
            }
            &:focus-visible {
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            null,
                            css`
                                outline-color: ${ADIColors.darkBlack3};
                                outline-style: ${getProp("theme.focus.style", "solid")};
                                outline-width: 1px;
                                outline-offset: 1px;
                            `,
                        ],
                        "min",
                    );
                }}
            } 
            > span:first-child {
                display: flex;

                > span {
                    align-items: center;
                    font-size: 14px;
                    font-weight: 600;
                    display: flex;
                    justify-content: flex-end;
                }
            }
            > span :nth-child(2) {
                margin-top: 8px;
                font-size: 10px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                color: ${ADIColors.darkBlue1};
                margin-right:18px;
             
      ${({ theme }: { theme: BaseTheme }) =>
          breakpointMediaQueries(
              theme,
              [
                  css`
                      margin-right: 0px;
                  `,
                  css`
                      margin-right: 0px;
                  `,
                  css``,
                  null,
                  null,
              ],
              "max",
          )}
 
 
            }
            }
        `,
    },
    titleIcon: {
        size: 22,
    },
    titleTypography: {
        css: css`
            font-size: 14px;
            color: ${getColor("secondary")};
            font-weight: 500;
            text-transform: capitalize;
            display: inline-block !important;
            margin: 0px 16px 0px 0px;
            + span {
                display: inline-block !important;
                height: 16px;
                width: 16px;
                > svg {
                    width: 14px;
                    height: 14px;
                    position: relative;
                    top: 2px;
                    color: ${ADIColors.darkBlue1};
                }
            }
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    css`
                        max-width: 80px;
                    `,
                    css`
                        max-width: 100px;
                    `,
                ]);
            }}
        `,
        ellipsis: true,
        transform: "capitalize",
    },
    signOutClickable: {
        css: css`
            width: 100%;
            font-size: 14px;
            min-height: 68px;
            padding: 0 20px;
            color: ${getColor("primary")};
            display: block;
            box-sizing: border-box;
            margin-bottom: 1rem !important;
            font-weight: bold;
            outline: none;
            border-top: 1px solid ${getColor("common.border")};
            &:hover {
                text-decoration: underline;
            }
        `,
    },
    menu: {
        cssOverrides: {
            wrapper: css`
                flex: 0 1 auto;
                min-width: 0;
            `,
            menu: css`
                ${({ theme }) => {
                    return breakpointMediaQueries(theme, [
                        css`
                            display: none !important;
                        `,
                        css`
                            display: none !important;
                        `,
                        css`
                            left: -5rem;
                        `,
                        null,
                        null,
                    ]);
                }}
            `,
        },
    },
    signInDrawer: {
        position: "right",
        size: 350,

        closeButtonProps: {
            shape: "pill",
            buttonType: "solid",
            color: "common.background",
            size: 36,
            hoverStyle: {
                background: "transparent",
                borderColor: "transparent",
            },
            activeStyle: {
                background: "transparent",
                borderColor: "transparent",
            },
            css: css`
                z-index: 1;
            `,
        },
        cssOverrides: {
            scrim: css`
                top: 85px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            top: 0px !important;
                        `,
                        css`
                            top: 0px !important;
                        `,
                        css`
                            top: 0px !important;
                        `,
                        css`
                            top: 115px !important;
                        `,
                        css`
                            top: 115px !important;
                        `,
                    ])}
            `,
            drawerTitle: css`
                background: ${getColor("common.background")};
                position: absolute;
                align-self: flex-end;
                margin: 10px;
                background: transparent;
                right: 5px;
                button {
                    position: relative;
                    top: -17px;
                    left: 15px;
                    border: none;
                    background-color: transparent;
                    svg {
                        line {
                            height: 16px !important;
                            width: 16px !important;
                        }
                    }
                }
            `,

            drawerContent: css`
                /* Target only Firefox */
                @-moz-document url-prefix() {
                    scrollbar-width: thin;
                    scrollbar-color: ${ADIColors.gray2} ${ADIColors.white};
                }
                &::-webkit-scrollbar {
                    width: 4px;
                }

                &::-webkit-scrollbar-track {
                    background: ${getColor("common.background")};
                }

                &::-webkit-scrollbar-thumb {
                    background-color: ${getColor("common.border")};
                    border-radius: 7px;
                }
            `,
            drawerBody: css`
                overflow: hidden auto;
                max-height: calc(100vh - 88px);
                margin: 2px;
                top: 85px;
                width: 375px;
                height: 100%;
                border-radius: 0;
                padding-top: 10px;
                padding-right: 5px;
                padding-bottom: 10px;
                cursor: default;
                margin-top: -0.1px;
                background: white;
                transform-origin: 100% 50%;
                animation: menuanimation 0.8s;
                box-shadow: inset -2px 5px 4px -4px rgba(0, 0, 0, 0.28);
                overflow-x: hidden;
                .accountSection {
                    background-color: #f7f7f7 !important;
                }
                .accountHeadingSection {
                    all: unset;
                    font-weight: bold;
                }
                .changeLinkSection {
                    margin-bottom: 20px !important;
                }
                .accountSectionHeight {
                    margin-bottom: 0px !important;
                }
                .accountBgSection {
                    flex: 1;
                    height: auto;
                    max-height: fit-content;
                    margin-top: 10px !important;
                }
                .bgNewSection {
                    flex: 1 1 100%;
                    width: 100%;
                }
                .linkSection {
                    background-color: white !important;
                }
                @keyframes menuanimation {
                    0% {
                        right: -374px;
                    }
                    100% {
                        right: 0px;
                    }
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            top: 0px !important;
                            width: 100%;
                            margin: 0;
                            max-height: 100%;
                            box-shadow: none;
                            background: linear-gradient(180deg, rgb(247 247 247) 20%, #ffffff 0%);
                        `,
                        css`
                            top: 0px !important;
                            width: 100%;
                            margin: 0;
                            max-height: 100%;
                            box-shadow: none;
                            background: linear-gradient(180deg, rgb(247 247 247) 20%, #ffffff 0%);
                        `,
                        css`
                            top: 0px !important;
                            max-height: 100%;
                            box-shadow: none;
                            background: linear-gradient(180deg, rgb(247 247 247) 20%, #ffffff 0%);
                        `,
                        css`
                            top: 115px !important;
                        `,
                        css`
                            top: 115px !important;
                        `,
                    ])}
            `,
        },

        headlineTypographyProps: {
            color: "text.main",
        },
    },
    myAccountMenuTitle: {
        css: css`
            font-size: 20px;
            margin: 18px 0px;
            font-weight: bold;
            cursor: default;
            line-height: 1.43;
            width: 100%;
            overflow: hidden;
            padding: 0 20px;
        `,
    },
    myAccountMenuGridContainer: {
        css: css`
            font-size: 24px;
            margin: 15px 0 15px;
            font-weight: bold;
            cursor: default;
            line-height: 1.43;
            width: 100%;
            overflow: hidden;
            padding: 0 20px;
            flex: 1;
            height: auto;
            max-height: fit-content;
        `,
        offsetCss: css`
            flex-direction: column;
            margin: 0 auto;
            list-style: none;
            margin: 0;
            width: 100%;
            float: left;
            overflow: hidden;
            background: ${getColor("common.background")};
        `,
    },
    myAccountMenuGridItem: {
        css: css`
            flex-basis: 100%;
            max-width: 100%;
            padding: 0px;
            list-style: none;
            width: 100%;
            float: left;
            margin: 0 0 14px !important;
            cursor: default;
            line-height: normal;
            font-size: 14px;
            font-weight: 600;
        `,
    },
    myAccountMenuLink: {
        css: css`
            outline: none;
            > span {
                color: ${getColor("text.main")} !important;
            }
            &:hover {
                > span {
                    color: ${getColor("text.main")} !important;
                    text-decoration: underline;
                }
            }
            &:focus {
                outline: none;
            }
            &:focus-visible {
                outline-offset: -1px;
                outline-color: ${getProp("theme.focus.color", "#09f")};
                outline-style: ${getProp("theme.focus.style", "solid")};
                outline-width: ${getProp("theme.focus.width", "2px")};
            }
        `,
    },
    chatWithUs: {
        css: css`
            width: 100%;
            background: ${getColor("common.accent")};
            text-align: center;
            cursor: auto;
        `,
    },
    chatWithUsLink: {
        css: css`
            font-size: 12px;
            font-weight: bold;
            padding: 23px 0;
            display: block;
            line-height: normal;
            width: 100%;
            > span {
                color: ${getColor("text.main")} !important;
                &:hover {
                    text-decoration: underline;
                }
            }
        `,
    },
    divider: {
        css: css`
            border-top: 1px solid ${getColor("common.border")};
            margin: 0 20px;
        `,
    },
    mainWraper: {
        css: css`
            text-align: center;
            align-self: center;
            width: 326px;
            background-color: ${getColor("common.background")};
            padding: 20px 0;
            border-bottom: 1px solid ${getColor("common.border")};
            border-top: 1px solid ${getColor("common.border")};
            margin: 0 20px;
            position: relative;
        `,
    },
    mainWraperLast: {
        css: css`
            text-align: center;
            align-self: center;
            width: 100%;
            background-color: ${getColor("common.background")};
            padding: 20px 30px;
            margin-bottom: 1rem;
        `,
    },
    mainWraperText: {
        css: css`
            font-size: 14px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: center;
            color: #2d2926;
        `,
    },
    mainWraperHint: {
        css: css`
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: center;
            margin-top: 9px;
            margin-bottom: 2px;
            color: #2d2926;
            width: max-content;
            margin-right: auto;
            margin-left: auto;
        `,
    },
    mainWraperLink: {
        css: css`
            margin-bottom: 0;
            justify-content: center;
            font-size: 14px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.43;
            letter-spacing: normal;
            text-align: center;
            margin-top: 9px;
            padding: 0;
            text-transform: none;
            > ${TypographyStyle} {
                color: #004da6; // No color present in style guide
            }
            &:hover {
                > ${TypographyStyle} {
                    text-decoration: underline;
                }
            }
        `,
    },
    customerNumber: {
        css: css`
            padding-bottom: 0px;
            flex-basis: 100%;
            max-width: 100%;
            padding: 0px 10px 6px 0px;
            color: ${getColor("text.main")};
            font-size: 14px;
            font-weight: bold;
            line-height: 1.43 !important;
            margin-top: 0;
            > ${TypographyStyle} {
                padding-left: 6px;
                position: relative;
                top: -1px;
            }
            button {
                margin: 0;
                &:focus {
                    outline: 1px solid ${ADIColors.darkBlack3};
                    text-decoration: none;
                    outline-offset: -1px;
                }
            }
        `,
    },
    addressInfo: {
        css: css`
            flex-basis: 100%;
            max-width: 100%;
            padding: 0px;
            color: ${getColor("text.main")};
            font-size: 14px;
            font-weight: 600;
            line-height: 1.43;
            line-height: normal;
            margin-top: 0;
            text-transform: capitalize;
        `,
    },
    adiModal: {
        css: css`
            display: flex;
            flex-direction: column;
            min-height: calc(100vh - 88px);
            align-items: flex-start;
        `,
    },
};

interface OwnProps extends WidgetProps {
    fields: {
        [fields.visibilityState]: string;
        [fields.icon]: string;
        [fields.includeAccountMenu]: boolean;
    };
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

let icon: React.ComponentType<IconPresentationProps>;
export const HeaderSignIn = ({
    id,
    userName,
    isSigningIn,
    firstName,
    lastName,
    isSignInPage,
    currentUserIsGuest,
    signOut,
    cancelPunchOut,
    fields,
    history,
    myAccountPageLink,
    signInUrl,
    isPunchOutSession,
    currentLocation,
    displayChangeCustomerLink,
    cart,
    billToState,
    shipToState,
    session,
    toggleDrawer,
    toggleLoginDrawer,
    setNavDrawerIsOpen,
    toggleRewardsDrawer,
    loadCurrentShipTo,
    currentShipToState,
    isCheckoutPage,
    userRoles,
    showAdminMenuonSite,
    showMyAccMenuItems,
    isAuthenticated,
    timeoutSetting,
    signInPageUrl,
}: Props) => {
    const showIcon = fields.visibilityState === "both" || fields.visibilityState === "icon";
    const showLabel = fields.visibilityState === "both" || fields.visibilityState === "label";
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [isAdministrator, setIsAdministrator] = useState(false);
    const [isSignInLoading, setIsSignInLoading] = useState(false); // this will replace by settings API Site Timeout Minutes Value
    const [sessionTimeoutDuration, setSessionTimeoutDuration] = useState(0); // this will replace by settings API Site Timeout Minutes Value
    const [isTabSwitched, setIsTabSwitch] = useState(false);
    const [Logout, setLogout] = useState<boolean>(true);

    const [isLoading, setIsLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState("");

    const currentState = useSelector((state: CustomApplicationState) => state);
    const loyaltyState = useSelector((state: CustomApplicationState) => state.ADIGlobalData?.loyaltyRewardStore);
    const rewardDrawerState = useSelector((state: CustomApplicationState) => state.ADIGlobalData?.rewardsDrawerStore);
    const isProRewardsUser = userRoles && userRoles.includes("ADIProRewards");
    const onLoadRef = useRef(false);
    const [isLoyaltyRewardUserLoaded, setIsLoyaltyRewardUserLoaded] = useState(false);
    const [showCustomerStatusBanner, setShowCustomerStatusBanner] = useState<boolean>();
    let roles: Array<string> = [];

    const customerSettings = useSelector((state: ApplicationState) => getSettingsCollection(state).customerSettings);
    const allowedUserRole = customerSettings.allowedUserRole;
    const enableAdiXtenIntegration = customerSettings.enableAdiXtenIntegration;
    roles = getMenuItems(showMyAccMenuItems);

    const dispatch: any = useDispatch();
    const location = useLocation();

    const pathLinks = [
        "/checkout/reviewandpay",
        "/cart",
        "/myaccount/changecustomer",
        "/myaccount/invoices/invoicepaymentrecap",
    ];
    const fetchLoyaltyRewardsByUserId = () => {
        const cart = getCurrentCartState(currentState);
        const billToState = getBillToState(currentState, cart?.value?.billToId);
        if (isProRewardsUser && billToState?.value) {
            onLoadRef.current = true;
            dispatch(loadLoyaltyRewards({ userID: formatUserId(billToState.value?.customerNumber) }));
        }
    };

    const getCustomerCreditStatus = useSelector(
        (state: CustomApplicationState) => state.ADIGlobalData.PricingStatusStore,
    );
    // session time-out handling

    // Store the session start time in UTC if not already set
    const initializeSessionStartTime = () => {
        const sessionStartTime = localStorage.getItem("sessionStartTime");
        if (sessionStartTime == null && isAuthenticated && billToState && billToState.value?.customerNumber) {
            const newSessionStartTime = new Date().toISOString(); // Get current UTC time
            localStorage.setItem("sessionStartTime", newSessionStartTime);
        }
    };

    // Check if the session has expired
    const checkSessionExpired = () => {
        const sessionStartTime = localStorage.getItem("sessionStartTime");
        if (!sessionStartTime) {
            return;
        }
        const currentTime = new Date().getTime(); // Current UTC time in milliseconds
        const sessionStartTimestamp = new Date(sessionStartTime).getTime(); // Session start time in milliseconds
        const elapsedTime = currentTime - sessionStartTimestamp; // Calculate the elapsed time

        // Check if the elapsed time exceeds the session timeout duration
        if (sessionTimeoutDuration !== 0 && elapsedTime > sessionTimeoutDuration) {
            setSessionTimeoutDuration(0);
            sessionStorage.clear();
            localStorage.clear();
            onSignOutHandler();
        }
    };

    const handleVisibilityChange = () => {
        if (document.hidden) {
            setIsTabSwitch(false); // The user switched to a different tab or minimized the browser
        } else {
            setIsTabSwitch(true); // The user returned to the current tab
        }
    };

    const fetchLoyaltyRewardsUserDetails = () => {
        const cart = getCurrentCartState(currentState);
        const billToState = getBillToState(currentState, cart?.value?.billToId);
        if (billToState?.value) {
            setIsLoyaltyRewardUserLoaded(true);
            dispatch(loadLoyaltyRewardsUser({ userID: formatUserId(billToState.value?.customerNumber) }));
        }
    };

    useEffect(() => {
        document.addEventListener("visibilitychange", handleVisibilityChange);
        // Cleanup the event listener on component unmount
        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    useEffect(() => {
        if (isTabSwitched) {
            checkSessionExpired();
            setIsTabSwitch(false);
        }
    }, [isTabSwitched]);

    useEffect(() => {
        if (sessionTimeoutDuration === 0 && isAuthenticated) {
            setSessionTimeoutDuration(timeoutSetting as number);
        }
    }, [timeoutSetting]);

    useEffect(() => {
        initializeSessionStartTime();
        checkSessionExpired();
    }, [session, currentState]);

    useEffect(() => {
        if (!onLoadRef.current) {
            fetchLoyaltyRewardsByUserId();
        }
        if (!isLoyaltyRewardUserLoaded) {
            fetchLoyaltyRewardsUserDetails();
        }
    }, [currentState]);

    if (fields.icon === "User") {
        icon = User;
    }

    useEffect(() => {
        const isAdmin =
            userRoles &&
            userRoles.includes("Administrator") &&
            (showAdminMenuonSite || window.location.host.indexOf("admin.") !== -1);
        setIsAdministrator(isAdmin);
    }, [userRoles]);

    const changeCustomerMethod = () => {
        history.push("/MyAccount/ChangeCustomer");
        if (toggleDrawer) {
            toggleLoginDrawer({ loginDrawer: false });
        }
    };

    const styles = useMergeStyles("headerSignIn", headerSignInStyles);

    const onSignInHandler = () => {
        setIsSignInLoading(true);

        setIsDrawerOpen(prevState => !prevState);

        if ((!userName || currentUserIsGuest) && !isSignInPage) {
            if (!signInUrl) {
                logger.warn("No URL was found for SignInPage, defaulting to /SignIn");
                history.push("/MyAccount/SignIn");
            }
        }
        setNavDrawerIsOpen({ navDrawerIsOpen: false });
        if (rewardDrawerState.rewardsDrawer) toggleRewardsDrawer({ rewardsDrawer: false });
    };

    const onSignOutHandler = () => {
        if (window) {
            window.sessionStorage.removeItem("adi_pricespider_webtoken");
            window.localStorage.removeItem("warehouseCode");
            window.localStorage.removeItem("warehouseDisplayName");
            window.localStorage.removeItem("warehouseNameSection");
        }
        isPunchOutSession ? cancelPunchOut() : signOut();
        clearCoveoTokenAndOrg();
        preventBackNavigation();
        window.localStorage.setItem("compareProducts", "[]");
        localStorage.removeItem("sessionStartTime");
        setLogout(false);
    };

    useEffect(() => {
        const firstNameOnly = `${firstName}`;
        if (userName && !currentUserIsGuest) {
            if (firstNameOnly === " ") {
                const fullNameWithoutSpace = firstNameOnly.replace(/\s+/g, "");
                setLoggedIn(fullNameWithoutSpace || userName);
            } else {
                setLoggedIn(firstNameOnly || userName);
            }
        }
    }, [userName && currentUserIsGuest]);

    const onIconClick = () => {
        toggleLoginDrawer({ loginDrawer: true });
    };

    const closeModal = () => {
        toggleLoginDrawer({ loginDrawer: false });
        setIsDrawerOpen(false);
        window.scrollTo(0, 0);
        resetLiveChat();
    };

    const resetLiveChat = () => {
        const isLiveChat = sessionStorage.getItem("openLiveChat");
        if (isLiveChat === "true") {
            localStorage.setItem("openLiveChat", "false");
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const BecomeACustomer = () => {
        closeModal();
        history.push("/Accounts/BecomeACustomer");
    };
    const RegisterAccount = () => {
        closeModal();
        history.push("/MyAccount/signin");
    };

    const resetInvoiceTabHeader = (url: string) => {
        if (url === "/myaccount/Invoices") {
            dispatch({
                type: "Custom/TabStatusUpdate",
                result: 0,
            });
        }
    };
    const afterSignInDrawer = () => {
        if (toggleDrawer) {
            return;
        }
        setNavDrawerIsOpen({ navDrawerIsOpen: false });
        if (rewardDrawerState.rewardsDrawer) {
            toggleRewardsDrawer({ rewardsDrawer: false });
        }
        toggleLoginDrawer({ loginDrawer: !isDrawerOpen });
        setIsDrawerOpen(!isDrawerOpen);
    };

    // Customerstatus API call
    const getCustomerStatus = () => {
        dispatch(
            DispatchGetcustomerStatusApi({
                userID: "",
            }),
        );
    };

    useEffect(() => {
        if (isAuthenticated && Logout) {
            if (pathLinks.includes(location.pathname.toLocaleLowerCase())) {
                getCustomerStatus();
            }
        }
    }, [location.pathname]);

    useEffect(() => {
        if (isAuthenticated && Logout) getCustomerStatus();
    }, []);

    useEffect(() => {
        if (toggleDrawer) {
            if (!isSigningIn) {
                setIsLoading(false);
                isAuthenticated && toggleLoginDrawer({ loginDrawer: false });
            } else {
                setIsLoading(true);
            }
        }
    }, [isSigningIn, isAuthenticated]);

    useEffect(() => {
        toggleLoginDrawer({ loginDrawer: isDrawerOpen });

        const transitionDuration = 300;
        const timer = setTimeout(() => {
            setIsSignInLoading(false);
        }, transitionDuration);

        if (isDrawerOpen) {
            const headerSearchPopover = document.querySelector("#headerSearch-popover");
            if (headerSearchPopover) {
                const headerSearchPopoverElement = headerSearchPopover as HTMLElement;
                headerSearchPopoverElement.style.display = "none";
            }
            const overlaySearchPopover = document.getElementById("overlay-div");
            if (overlaySearchPopover) {
                overlaySearchPopover.style.display = "none";
            }
            document.documentElement.style.overflowY = "";
            document.body.style.overflowY = "";
        }

        return () => clearTimeout(timer);
    }, [isDrawerOpen]);

    let myAccountLinks =
        myAccountPageLink?.children?.filter(
            pageLink => !(pageLink.type === "ChangeCustomerPage" && !displayChangeCustomerLink),
        ) ?? [];
    if (isProRewardsUser && checkVaildUserForHmiRewards(loyaltyState.loyalty)) {
        const accountIndex = myAccountLinks.findIndex((item: any) => item.title.toLowerCase() === "account");
        const proRewardsObject = {
            children: [],
            excludeFromNavigation: false,
            id: "122",
            parentId: "32",
            title: "ADI Pro Rewards",
            type: "AccountSettingsPage",
            url: "/myaccount",
        };
        myAccountLinks.splice(accountIndex + 1, 0, proRewardsObject);
        roles.push("ADI Pro Rewards");
    }

    if (!enableAdiXtenIntegration || !IsXtenAllowedUser(allowedUserRole)) {
        interface Link {
            title: string;
        }
        myAccountLinks = myAccountLinks.filter((item: Link) => item.title !== "XTEN-AV");
    }

    // ADINA-57194 fix
    myAccountLinks = myAccountLinks.map(item => {
        if (item.title === "Returns") {
            return { ...item, url: "/returns" };
        }
        return item;
    });

    if (styles.signInDrawer && styles.signInDrawer.cssOverrides.drawerBody) {
        if (isAuthenticated) {
            styles.signInDrawer.cssOverrides.drawerBody[0] = styles.signInDrawer.cssOverrides.drawerBody[0].replace(
                /background:\s*white;/g,
                "background:#f7f7f7;",
            );
        }
    }

    const cssStyle = {
        css: css`
            text-decoration: ${toggleDrawer ? "underline" : ""};
            text-decoration-color: ${toggleDrawer ? "#020508" : ""};
            text-decoration-thickness: ${toggleDrawer ? "4px" : ""};
            text-underline-offset: ${toggleDrawer ? "20px" : ""};
            padding: ${isAuthenticated ? "0 15px 0 0;" : "0 8px 0 0;"};
            color: ${isAuthenticated ? `${ADIColors.darkBlue1}` : `${ADIColors.darkBlue1}`};
        `,
    };
    const cssBorderStyle = {
        css: css`
            border-bottom: ${toggleDrawer && "4px solid #020508"};
            height: ${toggleDrawer && "58px"};
        `,
    };
    return (
        <StyledWrapper {...styles.signOutWrapper} {...cssBorderStyle}>
            {isAuthenticated && billToState.value?.customerNumber && (
                <Menu
                    descriptionId="accountMenu"
                    menuItems={[]}
                    displayChangeCustomerLink={displayChangeCustomerLink}
                    maxDepth={1}
                    onClick={afterSignInDrawer}
                    onKeyDown={e => {
                        if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            afterSignInDrawer();
                        }
                    }}
                    menuTrigger={
                        <Clickable {...styles.titleClickable} data-test-selector="header_signIn" target="_self">
                            {showIcon && <Icon {...styles.titleIcon} src={icon} />}
                            {showLabel && (
                                <>
                                    <Hidden below="lg" as="span">
                                        <Typography
                                            {...styles.titleTypography}
                                            data-test-selector="header_userName"
                                            style={{
                                                color: isAuthenticated ? "#002856" : "#002856",
                                                cursor: "pointer",
                                                margin: isAuthenticated ? "0px 0px 0px 0px" : "0px 16px 0px 0px",
                                            }}
                                        >
                                            {`Hi, ${loggedIn}`}
                                        </Typography>
                                        <StyledIcon src={ChevronDown} {...styles.menuItemIcon} />
                                    </Hidden>
                                    <Typography>{billToState.value?.customerNumber}</Typography>
                                </>
                            )}
                        </Clickable>
                    }
                    {...styles.menu}
                    data-test-selector="header_accountMenu"
                ></Menu>
            )}

            {!isAuthenticated && (
                <Clickable {...styles.titleClickable} onClick={onSignInHandler} data-test-selector="header_signIn">
                    {showIcon && <Icon {...styles.titleIcon} src={icon} />}
                    {showLabel && (
                        <Hidden below="lg" as="span">
                            <Typography {...styles.titleTypography} className="header-signin-text" {...cssStyle}>
                                {translate("Sign In")}
                            </Typography>
                        </Hidden>
                    )}
                </Clickable>
            )}

            {/* Drawer */}
            <Drawer
                isOpen={toggleDrawer}
                {...styles.signInDrawer}
                handleClose={() => closeModal()}
                data-test-selector="signInDrawer"
                onAfterClose={() => closeModal()}
            >
                <LoadingOverlay loading={isLoading} {...styles.loadingOverlay}>
                    <StyledWrapper className="ADIModal" {...styles.adiModal}>
                        {!isAuthenticated || isSignInLoading || isLoading ? (
                            <>
                                <Zone zoneName="signIn" contentId={id} />

                                <StyledWrapper {...styles.mainWraper}>
                                    <StyledWrapper {...styles.mainWraperText}>
                                        {translate("Already have an ADI account in the branch?")}
                                    </StyledWrapper>
                                    <StyledWrapper {...styles.mainWraperHint}>
                                        {translate("Connect your account number to our website.")}
                                    </StyledWrapper>
                                    <StyledWrapper> 
                                        <Link
                                            className="myAccountMenuLink"
                                            onClick={() => RegisterAccount()}
                                            data-category-name="myAccountMenu"
                                            {...styles.mainWraperLink}
                                        >
                                            {translate("Connect Existing Account")}
                                        </Link>
                                    </StyledWrapper>
                                </StyledWrapper>
                                <StyledWrapper {...styles.mainWraperLast}>
                                    <StyledWrapper {...styles.mainWraperText}>{translate("New to ADI?")}</StyledWrapper>
                                    <StyledWrapper {...styles.mainWraperHint}>
                                        {translate("Easily shop from our vast inventory of top brands.")}
                                    </StyledWrapper>
                                    <StyledWrapper>
                                        <Link
                                            className="myAccountMenuLink"
                                            onClick={() => BecomeACustomer()}
                                            data-category-name="myAccountMenu"
                                            {...styles.mainWraperLink}
                                        >
                                            {translate("Become a Customer")}
                                        </Link>
                                    </StyledWrapper>
                                </StyledWrapper>
                            </>
                        ) : (
                            <>
                                <StyledWrapper
                                    {...styles.myAccountMenuTitle}
                                    className="accountSection accountSectionHeight"
                                >
                                    My Account
                                </StyledWrapper>
                                <GridContainer
                                    className="myAccountMenuGridContainer accountSection accountBgSection"
                                    data-test-selector="myAccountMenuGridContainer"
                                    {...styles.myAccountMenuGridContainer}
                                    as="ul"
                                >
                                    <GridItem
                                        className="myAccountMenuGridItem accountSection"
                                        {...styles.customerNumber}
                                        as="li"
                                    >
                                        <strong className="accountHeadingSection">
                                            Account # {billToState.value?.customerNumber}{" "}
                                        </strong>
                                        {session.displayChangeCustomerLink && (
                                            <>
                                                <Typography>|&nbsp;&nbsp;</Typography>
                                                <Link onClick={changeCustomerMethod} className="changeLinkSection">
                                                    {translate("Change")}
                                                </Link>
                                            </>
                                        )}
                                    </GridItem>
                                    <GridItem
                                        className="myAccountMenuGridItem accountSection"
                                        {...styles.addressInfo}
                                        as="li"
                                    >
                                        {billToState.value?.companyName.toLowerCase()}
                                    </GridItem>
                                    <GridItem
                                        className="myAccountMenuGridItem accountSection"
                                        {...styles.addressInfo}
                                        as="li"
                                    >
                                        {shipToState.value?.address1.toLowerCase()},&nbsp;
                                        {shipToState.value?.city.toLowerCase()},&nbsp;
                                    </GridItem>
                                    <GridItem
                                        className="myAccountMenuGridItem accountSection"
                                        {...styles.addressInfo}
                                        as="li"
                                    >
                                        {shipToState.value?.state?.name.toLowerCase()}&nbsp;
                                        {shipToState.value?.postalCode}
                                    </GridItem>
                                </GridContainer>
                                <StyledWrapper className="linkSection bgNewSection">
                                    <GridContainer
                                        className="myAccountMenuGridContainer linkSection"
                                        data-test-selector="myAccountMenuGridContainer"
                                        {...styles.myAccountMenuGridContainer}
                                        as="ul"
                                    >
                                        {myAccountLinks
                                            .filter(
                                                l =>
                                                    l?.type === "QuickOrderPage" ||
                                                    (!l.excludeFromNavigation &&
                                                        ![
                                                            "AddressesPage",
                                                            "ChangeCustomerPage",
                                                            "OrderApprovalListPage",
                                                            "SavedOrderListPage",
                                                            "UserListPage",
                                                            "ADIAdminPage",
                                                        ].includes(l.type!)),
                                            )
                                            .map(item => (
                                                <React.Fragment key={item.id}>
                                                    {!roles.includes(item.title.trim()) ? null : (
                                                        <>
                                                            <GridItem
                                                                className="myAccountMenuGridItem"
                                                                {...styles.myAccountMenuGridItem}
                                                                key={item.id}
                                                                as="li"
                                                            >
                                                                <Link
                                                                    className="myAccountMenuLink"
                                                                    {...styles.myAccountMenuLink}
                                                                    href={item.url}
                                                                    onClick={() => {
                                                                        if (item.id === "122") {
                                                                            dispatch({
                                                                                type: "AccountPage/ProRewardsUpdate",
                                                                            });
                                                                            closeModal();
                                                                        } else {
                                                                            resetInvoiceTabHeader(item.url);
                                                                            closeModal();
                                                                            window.scrollTo(0, 0);
                                                                        }
                                                                    }}
                                                                    data-category-name="myAccountMenu"
                                                                >
                                                                    {item.title.toLowerCase() === "view my statements"
                                                                        ? "Statements"
                                                                        : item.title.toLowerCase().trim() ===
                                                                            "my quotes"
                                                                          ? "My Quotes"
                                                                          : item.title.toLowerCase() === "account"
                                                                            ? "Account Dashboard"
                                                                            : item.title.toLowerCase().trim() ===
                                                                                "recently purchased products"
                                                                              ? "Recently Purchased"
                                                                              : item.title.toLowerCase() ===
                                                                                  "request quote form"
                                                                                ? "Request a Quote"
                                                                                : item.title.toLowerCase() ===
                                                                                    "my lists"
                                                                                  ? "My Lists"
                                                                                  : item.title.toLowerCase() ===
                                                                                      "my orders"
                                                                                    ? "My Orders"
                                                                                    : item.title.toLowerCase() ===
                                                                                        "xtensignup"
                                                                                      ? null
                                                                                      : item.title}
                                                                </Link>
                                                            </GridItem>
                                                        </>
                                                    )}
                                                </React.Fragment>
                                            ))}
                                    </GridContainer>
                                    {/* Commented the code below as per: ADINA 64717 */}
                                    {/* <ADILiveChatComponent isHeaderDrawer={true} /> */}
                                    <StyledWrapper {...styles.divider} className="linkSection" />
                                    {isAdministrator && (
                                        <>
                                            <StyledWrapper {...styles.myAccountMenuTitle} className="linkSection">
                                                Administration
                                            </StyledWrapper>
                                            <GridContainer
                                                className="myAccountMenuGridContainer linkSection"
                                                data-test-selector="myAccountMenuGridContainer"
                                                {...styles.myAccountMenuGridContainer}
                                                as="ul"
                                            >
                                                {/* <GridItem
                                                    className="myAccountMenuGridItem"
                                                    {...styles.myAccountMenuGridItem}
                                                    as="li"
                                                >
                                                    <Link
                                                        className="myAccountMenuLink"
                                                        {...styles.myAccountMenuLink}
                                                        href="/MyAccount/UserAdministration"
                                                        onClick={() => closeModal()}
                                                        data-category-name="myAccountMenu"
                                                    >
                                                        {translate("User Administration")}
                                                    </Link>
                                                </GridItem> */}
                                                <GridItem
                                                    className="myAccountMenuGridItem"
                                                    {...styles.myAccountMenuGridItem}
                                                    as="li"
                                                >
                                                    <Link
                                                        className="myAccountMenuLink"
                                                        {...styles.myAccountMenuLink}
                                                        href="/MyAccount/BannerList"
                                                        onClick={() => closeModal()}
                                                        data-category-name="myAccountMenu"
                                                    >
                                                        {translate("Banner List")}
                                                    </Link>
                                                </GridItem>
                                                <GridItem
                                                    className="myAccountMenuGridItem"
                                                    {...styles.myAccountMenuGridItem}
                                                    as="li"
                                                >
                                                    <Link
                                                        className="myAccountMenuLink"
                                                        {...styles.myAccountMenuLink}
                                                        href="/MyAccount/MarketingTileList"
                                                        onClick={() => closeModal()}
                                                        data-category-name="myAccountMenu"
                                                    >
                                                        {translate("Marketing Tile List")}
                                                    </Link>
                                                </GridItem>
                                                <GridItem
                                                    className="myAccountMenuGridItem"
                                                    {...styles.myAccountMenuGridItem}
                                                    as="li"
                                                >
                                                    <Link
                                                        className="myAccountMenuLink"
                                                        {...styles.myAccountMenuLink}
                                                        href="/myaccount/uploadimage"
                                                        onClick={() => closeModal()}
                                                        data-category-name="myAccountMenu"
                                                    >
                                                        {translate("Upload Images")}
                                                    </Link>
                                                </GridItem>
                                                <GridItem
                                                    className="myAccountMenuGridItem"
                                                    {...styles.myAccountMenuGridItem}
                                                    as="li"
                                                >
                                                    <Link
                                                        className="myAccountMenuLink"
                                                        {...styles.myAccountMenuLink}
                                                        href="/MyAccount/FBTUpload"
                                                        onClick={() => closeModal()}
                                                        data-category-name="myAccountMenu"
                                                    >
                                                        {translate("Customer Product View")}
                                                    </Link>
                                                </GridItem>
                                                <GridItem
                                                    className="myAccountMenuGridItem"
                                                    {...styles.myAccountMenuGridItem}
                                                    as="li"
                                                >
                                                    <Link
                                                        className="myAccountMenuLink"
                                                        {...styles.myAccountMenuLink}
                                                        href="/myaccount/VisualNavigationManager"
                                                        onClick={() => closeModal()}
                                                        data-category-name="myAccountMenu"
                                                    >
                                                        {translate("Visual Navigation Manager")}
                                                    </Link>
                                                </GridItem>
                                            </GridContainer>
                                        </>
                                    )}
                                    {userName && !currentUserIsGuest && (
                                        <Clickable
                                            {...styles.signOutClickable}
                                            onClick={onSignOutHandler}
                                            data-test-selector="headerSignOutLink"
                                            className="linkSection"
                                        >
                                            {isPunchOutSession ? translate("Cancel PunchOut") : translate("Sign Out")}
                                        </Clickable>
                                    )}
                                </StyledWrapper>
                            </>
                        )}
                    </StyledWrapper>
                </LoadingOverlay>
            </Drawer>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(HeaderSignIn)),
    definition: {
        displayName: "Header Sign In",
        icon: "arrow-right-to-bracket",
        fieldDefinitions: [
            {
                name: fields.visibilityState,
                displayName: "Settings",
                editorTemplate: "RadioButtonsField",
                options: [
                    {
                        displayName: "Both",
                        value: "both",
                    },
                    {
                        displayName: "Show Label",
                        value: "label",
                    },
                    {
                        displayName: "Show Icon",
                        value: "icon",
                    },
                ],
                defaultValue: "both",
                fieldType: "General",
                sortOrder: 1,
            },
            {
                name: fields.icon,
                displayName: "SignIn Icon",
                editorTemplate: "DropDownField",
                options: [
                    {
                        displayName: "User",
                        value: "User",
                    },
                ],
                defaultValue: "User",
                fieldType: "General",
                sortOrder: 2,
            },
            {
                name: fields.includeAccountMenu,
                displayName: "Include My Account Menu",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 3,
            },
        ],
        group: "Common",
    },
};

export default widgetModule;
